import { useTranslation } from 'react-i18next';
import { googleLogout } from '@react-oauth/google';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import { useAuth } from '../context/authContext';
import { useEffect } from 'react';

const UserProfilePage = () => {
    const { t, i18n } = useTranslation();  
    const googleProfile: any = localStorage.getItem('googleProfile');
    let googleUser: any = googleProfile ? JSON.parse(googleProfile) : null;
    const { logout, user, emailUsertokenExpired } = useAuth();
    const emailUser: any = user;
    const emailUserObj: any = JSON.parse(emailUser);
    const logOut = () => {
        if(googleProfile) {
            googleLogout();
        }
        if(user) {
            logout();
        }
        window.location.href = "/join";
        localStorage.removeItem('googleProfile');
    };

    useEffect(() => {
        emailUsertokenExpired()

    }, [])
    
    return (
        <div className="user-profile-page">
            <h1 className="page-h1">{i18n.exists("pages.user") ? t('pages.user') : "Потребител"}</h1>
            <div className="content-wrapper">
                <div>
                    {googleUser ? (
                        <div>
                            <Row className="mb-3">
                                <Col md="6" className="margin-0">
                                    <div className="features margin-0">
                                        <h2>{i18n.exists("pages.yourProfile") ? t('pages.yourProfile') : "Вашият Профил"}</h2>
                                        <ul>
                                            <li>{googleUser.picture ? (<img src={googleUser.picture.data && googleUser.picture.data.url ? googleUser.picture.data.url : googleUser.picture} alt="user" className='rounded img-responsive' />) : null}</li>
                                            <li><span>{i18n.exists("forms.name") ? t('forms.name') : "Име"}: </span><span>{googleUser.name}</span></li>
                                            <li><span>{i18n.exists("forms.email") ? t('forms.email') : "Имейл"}: </span><span>{googleUser.email}</span></li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col md="6" className="margin-0">
                                    <div className='features margin-0'>
                                        <Button onClick={logOut}>{i18n.exists("forms.logout") ? t('forms.logout') : "Излез"}</Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    ) : (
                        null
                    )}

                    {emailUser && !googleUser ? (
                        <div>
                            <Row className="mb-3">
                                <Col md="6" className="margin-0">
                                    <div className="features margin-0">
                                        <h2>{i18n.exists("pages.emailProfile") ? t('pages.emailProfile') : "Имейл Профил"}</h2>
                                        <ul>
                                            <li><span>{i18n.exists("forms.email") ? t('forms.email') : "Имейл"}: </span><span>{emailUserObj.email}</span></li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col md="6" className="margin-0">
                                    <div className='features margin-0'>
                                        <Button onClick={logOut}>{i18n.exists("forms.logout") ? t('forms.logout') : "Излез"}</Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    ) : (
                        null
                    )}

                    {!googleUser && !emailUser ? (
                         // <button onClick={login}>Sign in with Google 🚀 </button>
                         <Col md="6" className="margin-0">
                         <div className='features'>
                             <Button onClick={logOut}>{i18n.exists("forms.signin") ? t('forms.signin') : "Вход"}</Button>
                         </div>
                     </Col>
                    ) : null}
                </div>
            </div>
        </div>
    )
}

export default UserProfilePage;